export function escapeForJsonSearch(value: string): string {
  return value.replace(/\\/g, '\\\\').replace(/"/g, '\\"');
}
